import {
	Pedestrismo,
	RuralBike,
	CombinadaSimple
} from '../constants/enums';


/*
 * =======================================================
 * ATLETA HABILITADO PARA RESULTADOS / PREMIACION
 * =======================================================
 *
 * Debe:
 *
 * - tener tiempo registrado
 * - NO ser DNS
 * - NO ser DNF
 * - NO ser DSQ
 *
 * dnf todavía no existe en el modelo actual,
 * pero dejamos preparada la lógica.
 */
const isEligibleForResults = (
	participant
) => {

	if (
		!participant
	) {

		return false;
	}


	return (
		Number(
			participant.registeredTime1 || 0
		) > 0

		&&

		Number(
			participant.dns || 0
		) === 0

		&&

		Number(
			participant.dnf || 0
		) === 0

		&&

		Number(
			participant.disqualified || 0
		) === 0
	);
};


export const utilsFilterList = (
	participants
) => {

	let results =
		participants.slice(0);


	return results.filter(
		(participant) => {

			return isEligibleForResults(
				participant
			);
		}
	);
};


export const utilsGeneralFilter = (
	distanceType,
	participants
) => {

	let orderedList = [];


	orderedList =
		participants
			.filter(
				(p) => {

					return (
						isEligibleForResults(p)

						&&

						p.distance ===
							distanceType
					);
				}
			)
			.sort(
				(p1, p2) => {

					return (
						p1.registeredTime1 <
							p2.registeredTime1
							? -1
							: 1
					);
				}
			);


	return orderedList;
};


export const utilsGenderFilter = (
	distanceType,
	participants,
	gender
) => {

	let orderedList = [];


	orderedList =
		participants
			.filter(
				(p) => {

					return (
						isEligibleForResults(p)

						&&

						p.distance ===
							distanceType

						&&

						p.gender ===
							gender
					);
				}
			)
			.sort(
				(p1, p2) => {

					return (
						p1.registeredTime1 <
							p2.registeredTime1
							? -1
							: 1
					);
				}
			);


	return orderedList;
};


export const utilsGenderLocalesFilter = (
	distanceType,
	participants,
	gender,
	city
) => {

	let orderedList = [];


	/*
	 * Primero usamos utilsGenderFilter,
	 * que ya excluye DNS / DNF / DSQ.
	 */
	orderedList =
		utilsGenderFilter(
			distanceType,
			participants,
			gender
		)
			.filter(
				(p) => {

					return (
						String(
							p.city || ''
						)
							.toLowerCase()
							.trim()
						===
						String(
							city || ''
						)
							.toLowerCase()
							.trim()
					);
				}
			)
			.sort(
				(p1, p2) => {

					return (
						p1.registeredTime1 <
							p2.registeredTime1
							? -1
							: 1
					);
				}
			);


	return orderedList;
};


export const utilsCategoryFilter = (
	participants,
	category
) => {

	let orderedList = [];


	orderedList =
		participants
			.filter(
				(p) => {

					return (
						isEligibleForResults(p)

						&&

						p.catCod ===
							category

						&&

						p.formattedTime1 <=
							'9:00:00.0'
					);
				}
			)
			.sort(
				(p1, p2) => {

					return (
						p1.totalTime <
							p2.totalTime
							? -1
							: 1
					);
				}
			);


	return orderedList;
};


export const utilsCategoryFilter2 = (
	distanceType,
	participants,
	category
) => {

	let orderedList = [];


	orderedList =
		participants
			.filter(
				(p) => {

					return (
						isEligibleForResults(p)

						&&

						p.distance ===
							distanceType

						&&

						p.catCod ===
							category
					);
				}
			)
			.sort(
				(p1, p2) => {

					return (
						p1.totalTime <
							p2.totalTime
							? -1
							: 1
					);
				}
			);


	return orderedList;
};


export const utilsFormatDate = (
	input
) => {

	if (
		!input
	) {

		return "";

	} else {

		var datePart =
			String(input).match(
				/\d+/g
			);


		if (
			!datePart ||
			datePart.length < 3
		) {

			return "";
		}


		var year =
			datePart[0]
				.substring(2);


		var month =
			datePart[1];


		var day =
			datePart[2];


		return (
			day +
			'/' +
			month +
			'/' +
			year
		);
	}
};


export const utilsFormatTime = (
	showMilli,
	milliDiff
) => {

	let date =
		new Date(null);


	let result;


	date.setMilliseconds(
		milliDiff
	);


	if (
		showMilli
	) {

		result =
			date
				.toISOString()
				.substr(
					12,
					9
				);

	} else {

		result =
			date
				.toISOString()
				.substr(
					12,
					7
				);
	}


	return result;
};


/**
 * Solo utilizada para filtrar resultados
 * ordenados en monitor de clasificacion.
 */
export const utilsResultsQualifyFilter = (
	competition,
	participants,
	distance = null,
	gender,
	clase
) => {

	let results =
		participants.slice(0);


	let orderedList = [];


	if (
		competition ===
			Pedestrismo
	) {

		orderedList =
			results
				.filter(
					(participant) => {

						return (
							isEligibleForResults(
								participant
							)

							&&

							participant.distance ===
								distance

							&&

							(
								(
									participant.gender ===
										gender

									&&

									clase !== "G"
								)

								||

								clase === "G"
							)
						);
					}
				)
				.sort(
					(p1, p2) => {

						return (
							p1.registeredTime1 <
								p2.registeredTime1
								? -1
								: 1
						);
					}
				);
	}


	if (
		competition ===
			RuralBike
	) {

		if (
			clase === 'IN'
		) {

			orderedList =
				results
					.filter(
						(participant) => {

							return (
								isEligibleForResults(
									participant
								)

								&&

								participant.class ===
									clase

								&&

								participant.gender ===
									gender
							);
						}
					)
					.sort(
						(p1, p2) => {

							return (
								p1.registeredTime1 <
									p2.registeredTime1
									? -1
									: 1
							);
						}
					);

		} else {

			orderedList =
				results
					.filter(
						(participant) => {

							return (
								isEligibleForResults(
									participant
								)

								&&

								participant.class ===
									clase
							);
						}
					)
					.sort(
						(p1, p2) => {

							return (
								p1.registeredTime1 <
									p2.registeredTime1
									? -1
									: 1
							);
						}
					);
		}
	}


	if (
		competition ===
			CombinadaSimple
	) {

		if (
			clase === 'IN'
		) {

			orderedList =
				results
					.filter(
						(participant) => {

							return (
								isEligibleForResults(
									participant
								)

								&&

								participant.class ===
									clase

								&&

								participant.gender ===
									gender
							);
						}
					)
					.sort(
						(p1, p2) => {

							return (
								p1.registeredTime1 <
									p2.registeredTime1
									? -1
									: 1
							);
						}
					);

		} else {

			orderedList =
				results
					.filter(
						(participant) => {

							return (
								isEligibleForResults(
									participant
								)

								&&

								participant.class ===
									clase
							);
						}
					)
					.sort(
						(p1, p2) => {

							return (
								p1.registeredTime1 <
									p2.registeredTime1
									? -1
									: 1
							);
						}
					);
		}
	}


	return orderedList;
};


export const utilsPremiacionGeneral = (
	distanceType,
	participants,
	gender,
	top
) => {

	let orderedList = [];

	let winners = [];


	/*
	 * utilsGenderFilter ya excluye
	 * DNS / DNF / DSQ antes del TOP.
	 */
	orderedList =
		utilsGenderFilter(
			distanceType,
			participants,
			gender
		)
			.slice(
				0,
				top
			);


	let i = 0;


	winners =
		orderedList.map(
			(participant) => {

				i++;


				return {

					'idx':
						i,

					'pos':
						i,

					'number':
						participant.number,

					'fullname':
						participant.fullname,

					'age':
						participant.age +
						' (' +
						participant.birth +
						')',

					'city':
						participant.city,

					'time':
						participant.formattedTime1,

					'category_cod': participant.catCod,

					'category':
						participant.catCod
				};
			}
		);


	return winners;
};


export const utilsPremiacionCategorias = (
	participants,
	category,
	top
) => {

	let orderedList = [];

	let winners = [];


	/*
	 * utilsCategoryFilter ya excluye
	 * DNS / DNF / DSQ antes del TOP.
	 */
	orderedList =
		utilsCategoryFilter(
			participants,
			category
		)
			.slice(
				0,
				top
			);


	let i = 0;


	winners =
		orderedList.map(
			(participant) => {

				i++;


				return {

					'idx':
						i,

					'pos':
						i,

					'number':
						participant.number,

					'fullname':
						participant.fullname,

					'age':
						participant.age +
						' (' +
						participant.birth +
						')',

					'city':
						participant.city,

					'club':
						participant.club,

					'time':
						participant.formattedTime1,

					'category':
						participant.catName,

					'category_cod':
						participant.catCod
				};
			}
		);


	return winners;
};


export const utilsPremiacionCategorias2 = (
	distanceType,
	participants,
	category,
	top
) => {

	let orderedList = [];

	let winners = [];


	orderedList =
		utilsCategoryFilter2(
			distanceType,
			participants,
			category
		)
			.slice(
				0,
				top
			);


	let i = 0;


	winners =
		orderedList.map(
			(participant) => {

				i++;


				return {

					'idx':
						i,

					'pos':
						i,

					'number':
						participant.number,

					'fullname':
						participant.fullname,

					'age':
						participant.age +
						' (' +
						participant.birth +
						')',

					'city':
						participant.city,

					'time':
						participant.formattedTime1,

					'category':
						participant.catCod
				};
			}
		);


	return winners;
};


export const utilsPremiacionGeneralLocal = (
	distanceType,
	participants,
	gender,
	city,
	top
) => {

	let orderedList = [];

	let winners = [];


	/*
	 * utilsGenderLocalesFilter ya excluye
	 * DNS / DNF / DSQ antes del TOP.
	 */
	orderedList =
		utilsGenderLocalesFilter(
			distanceType,
			participants,
			gender,
			city
		)
			.slice(
				0,
				top
			);


	let i = 0;


	winners =
		orderedList.map(
			(participant) => {

				i++;


				return {

					'idx':
						i,

					'pos':
						i,

					'number':
						participant.number,

					'age':
						participant.age +
						' (' +
						participant.birth +
						')',

					'category_cod': participant.catCod,

					'category':
						participant.catCod,

					'fullname':
						participant.fullname,

					'city':
						participant.city,

					'time':
						participant.formattedTime1
				};
			}
		);


	return winners;
};



// WEBPACK FOOTER //
// ./src/utils/utilities.js